'use client';

import React from 'react';

export default function FloatingMapControls() {
  return null;
}